import React, { FC } from 'react'

import { getFullName } from 'helpers'
import { DropdownTypes, DropdownProps } from 'UI/Dropdown/types'
import { Dropdown, Avatar } from 'UI'
import { UserRole } from 'store/slices/system/types'

import cl from 'UI/Dropdown/style.module.scss'
import { dropdownIconSrc } from './images/icons'

export interface ProfileMenuProps extends DropdownProps {
	otherRolesInfo: UserRole[]
}

const ProfileMenu: FC<ProfileMenuProps> = ({
	dropdownItemsList,
	avatarParams = {},
	dropdownTitle,
	otherRolesInfo
}) => (
	<Dropdown
		dropdownTitle={dropdownTitle}
		dropdownItemsList={dropdownItemsList}
		otherRolesInfo={otherRolesInfo}
		type={DropdownTypes.PROFILE_MENU}
		avatarParams={avatarParams}
	>
		<Avatar {...avatarParams} />
		<div className={cl.profileInfo}>
			<span>
				{getFullName({
					firstName: avatarParams.firstName,
					lastName: avatarParams.lastName
				})}
			</span>
			<img src={dropdownIconSrc} alt="dropdown" />
		</div>
	</Dropdown>
)

export default ProfileMenu
